import axios from "@lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { generateHTML } from "@tiptap/html";
import { AxiosError } from "axios";
import { getMailRenderExtensions } from "../editorExtensions";
export interface Inputs {
  contentGroupId: string;
  title: string;
  subject: string;
  content: string;
  originalUrl?: string;
  summary?: string;
  image?: string;
  attachment?: any;
  subcategoryId?: string;
  themeId?: string;
  legislativeProposalId?: string;
  tags: [];
  authors: [];
  rapporteurs: [];
  onlySave?: boolean;
}

interface Props {
  contentId?: string;
  language: string;
  onSuccess?: (content, variables) => void;
  onError?: (res: AxiosError) => void;
}

export const useSaveContent = ({
  contentId,
  language,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();
  const {
    mutateAsync: onSaveContent,
    variables,
    ...rest
  } = useMutation({
    mutationFn: async ({
      tags,
      authors,
      attachment,
      rapporteurs,
      onlySave,
      ...data
    }: Inputs) => {
      if (tags) data.tagIds = tags.map((item) => item.value);
      if (authors) data.authorIds = authors.map((item) => item.value);
      if (rapporteurs)
        data.rapporteurIds = rapporteurs.map((item) => item.value);
      if (attachment) data.attachmentId = attachment.id;

      if (data.content) {
        data.content = JSON.stringify(data.content);

        data.htmlContent = generateHTML(
          JSON.parse(data.content),
          getMailRenderExtensions(language)
        );
      } else {
        data.htmlContent = "";
      }

      if (contentId) return axios.patch(`/contents/${contentId}`, data);
      return axios.post("/contents", data);
    },
    onSuccess: ({ data: { content } }) => {
      if (contentId)
        queryClient.invalidateQueries({ queryKey: ["content", contentId] });
      if (onSuccess) onSuccess(content, variables);
    },
    onError,
  });

  return { onSaveContent, variables, ...rest };
};
